import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "value"]

  static values = {
    frameId: String,
    urls: Object
  }

  connect() {
    this.sync()
  }

  change(event) {
    this.sync()

    const url = this.hasSelectTarget
      ? this.selectTarget.options[this.selectTarget.selectedIndex]?.dataset?.url
      : this.urlsValue[event.target.value]
    if (!url) return

    if (this.hasFrameIdValue && window.Turbo?.visit) {
      window.Turbo.visit(url, { frame: this.frameIdValue })
      return
    }

    if (this.hasFrameIdValue) {
      const frame = document.getElementById(this.frameIdValue)
      if (frame) {
        frame.setAttribute("src", url)
        return
      }
    }

    if (window.Turbo) {
      window.Turbo.visit(url)
    } else {
      window.location.assign(url)
    }
  }

  sync() {
    if (this.hasValueTarget && this.hasSelectTarget) {
      this.valueTarget.textContent = this.selectTarget.value
    }
  }
}
